import LogoOnly from '@/public/relance_comm.svg';

type Props = {
  size?: number;
};

export const RelanceCommLogo = ({ size }: Props) => {
  return <img width={size} src={LogoOnly} alt="リラコム" />;
};
